import { EnumEndpointsName } from "@/constants/app/type";
import { generateInitialState } from "@/utils/redux/generateInitialState";
import { generateInitialStateWithFilter } from "@/utils/redux/generateInitialStateWithFilter";
import { parseJson } from "@/utils/safeParse/parseJson";
import { EnumHotelSearchType, HotelState } from "./type";
import { defaultFilterData } from "@/constants/hotel/defaultFilterData";

export const initialStateHotel: HotelState = {
  searchingDestination: false,
  vietnamPopularDestinations: [],
  internationalPopularDestinations: [],
  popularGroupsInternal: [],
  popularGroupsExternal: [],
  typeSearch: 'INTERNAL',
  firstHotel: null,
  firstLoadingHotels: true,
  [EnumEndpointsName.HOTEL_GOOD_PRICES]: generateInitialState({ data: {} as any }),
  [EnumEndpointsName.HOTEL_MASTER_DETAIL]: generateInitialState({ data: {} as any }),
  [EnumEndpointsName.HOTEL_AREAS]: generateInitialState({ data: {} }),
  [EnumEndpointsName.HOTEL_BOOKING_CANCEL]: generateInitialState({ data: {} }),
  [EnumEndpointsName.HOTEL_BOOKING_CONFIRM_CANCEL]: generateInitialState({ data: {} }),
  [EnumEndpointsName.HOTEL_CITIES]: generateInitialState({ data: {} }),
  [EnumEndpointsName.HOTEL_COUNTRIES]: generateInitialState({ data: {} }),
  [EnumEndpointsName.HOTEL_DETAIL_STATISTICS]: generateInitialState({ data: { score: [] } }),
  [EnumEndpointsName.HOTEL_DETAIL_REVIEWS]: generateInitialState({ data: { items: [], pagination: {
    page: 1,
    pageSize: 20,
    total: 0,
    totalPages: 0,
    hasPrev: false,
    hasNext: false
  } } }),
  [EnumEndpointsName.HOTEL_DETAIL]: { ...generateInitialState({ data: {} as any }), feePolicies: [] },
  [EnumEndpointsName.HOTEL_DETAIL_RESOURCE]: generateInitialState({ data: {} }),
  [EnumEndpointsName.HOTEL_FILTER_OPTION]: generateInitialState({ data: {} }),
  [EnumEndpointsName.HOTEL_HEALTHZ]: generateInitialState({ data: {} }),
  [EnumEndpointsName.HOTEL_LOCATIONS_INIT]: generateInitialState({ data: {} }),
  [EnumEndpointsName.HOTEL_LOCATIONS_SEARCH]: generateInitialStateWithFilter({ data: {} }),
  [EnumEndpointsName.HOTEL_LOCATIONS_DETAIL]: generateInitialState({ data: {} as any }),
  [EnumEndpointsName.HOTEL_ORDER]: generateInitialState({ data: {} }),
  [EnumEndpointsName.HOTEL_ORDER_PRECHECK]: generateInitialState({ data: {} }),
  [EnumEndpointsName.HOTEL_SEARCH]: {
    ...generateInitialState({ data: {} }),
    primaryKeysForMaps: [],
    feePolicies: [],
  },
  [EnumEndpointsName.HOTEL_SEARCH_KEYWORD]: generateInitialState({ data: {} }),
  [EnumEndpointsName.HOTEL_SORT_OPTION]: generateInitialState({ data: [] }),
  mode: 'list',
  modeDetail: 'list',
  formSearch: {
    searchType: "",
    checkInDate: "",
    checkOutDate: "",
    roomsNum: 1,
    adults: 2,
    children: 0,
    childrenAges: [],
    page: 0,
    pageSize: 0,
    filter: {},
    sort: { selectOption: 1 },
    locale: "",
    searchMode: ""
  },
}